import React from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
  Divider,
} from "@material-ui/core";
import { NavLink } from "react-router-dom";
import DrawerComponent from "./Drawer";

import Icon1 from "../Images/Logo/IIT.png";
import Icon3 from "../Images/Logo/IGCS.png";

const useStyles = makeStyles((theme) => ({
  /* ================= HEADER ================= */

  header: {
    width: "100%",
    position: "relative",
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      padding: "10px 8px 0",
    },
  },

  topTitle: {
    textAlign: "center",
    color: "#ffffff",
    textShadow: "2px 2px 7px #000000",
    fontSize: "33px",
    lineHeight: 1.2,
    margin: "0 0 10px",

    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
      margin: "0 0 8px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "21px",
    },
  },

  /* ================= LOGOS ================= */

  logoRow: {
    width: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 35px",
    marginBottom: "10px",

    [theme.breakpoints.down("md")]: {
      padding: "0 15px",
      marginBottom: "10px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "0 10px",
    },
  },

  iitLogo: {
    width: "150px",
    height: "auto",

    [theme.breakpoints.down("md")]: {
      width: "75px",
    },

    [theme.breakpoints.down("sm")]: {
      width: "65px",
    },
  },

  igcsLogo: {
    width: "165px",
    height: "auto",

    [theme.breakpoints.down("md")]: {
      width: "85px",
    },

    [theme.breakpoints.down("sm")]: {
      width: "75px",
    },
  },

  /* ================= MAIN TITLE ================= */

  mainTitle: {
  textAlign: "center",
  color: "#ffffff",
  textShadow: "2px 2px 7px #000000",
  margin: "-105px auto 20px",
  position: "relative",
  zIndex: 2,

  "& h2": {
    margin: 0,
    fontSize: "44px",
    lineHeight: 1.2,
  },

    [theme.breakpoints.down("md")]: {
      margin: "5px auto 15px",

      "& h2": {
        fontSize: "27px",
        lineHeight: 1.25,
      },
    },

    [theme.breakpoints.down("sm")]: {
      margin: "5px auto 12px",

      "& h2": {
        fontSize: "21px",
        lineHeight: 1.3,
      },
    },
  },

  /* ================= IIT MADRAS ================= */

  instituteTitle: {
    textAlign: "center",
    color: "#ffffff",
    textShadow: "2px 2px 7px #000000",
    fontSize: "33px",
    lineHeight: 1.2,
    margin: "10px 0 10px",

    [theme.breakpoints.down("md")]: {
      fontSize: "25px",
      margin: "10px 0",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      lineHeight: 1.3,
    },
  },

  /* ================= DESKTOP NAV ================= */

  navlinks: {
    fontWeight: "bold",
    fontFamily: "calibri",
    alignItems: "center",
    display: "flex",
    textShadow: "2px 2px 6px #000000",
    width: "100%",
    justifyContent: "space-around",
  },

  link: {
    fontFamily: "calibri",
    textDecoration: "none",
    color: "#ffffff",
    fontSize: "20px",
    borderBottom: "1px solid transparent",
    margin: 0,

    "&:hover": {
      color: "#000000",
      borderBottom: "1px solid white",
    },

    [theme.breakpoints.down("lg")]: {
      fontSize: "17px",
    },
  },

  activeLink: {
    color: "#ffffff",
    borderBottom: "1px solid #000000",
  },

  toolbar: {
    background: "rgb(10 117 188)",
    minHeight: "78px",

    [theme.breakpoints.down("md")]: {
      minHeight: "55px",
      justifyContent: "center",
    },
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <AppBar
        position="relative"
        className="colors"
        style={{ width: "100%" }}
      >
        <div className={classes.header}>

          {/* DST Centre */}
          <Typography className={classes.topTitle}>
            DST-Centre of Excellence
          </Typography>

          {/* Logos */}
          <div className={classes.logoRow}>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://doe.iitm.ac.in/"
            >
              <img
                src={Icon1}
                alt="IIT"
                className={classes.iitLogo}
              />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.igcs-chennai.org/"
            >
              <img
                src={Icon3}
                alt="logo"
                className={classes.igcsLogo}
              />
            </a>

          </div>

          {/* Main Website Title */}
          <div className={classes.mainTitle}>

            <Typography variant="h2">
              Climate Change Impacts on Coastal Infrastructure
            </Typography>

            <Typography variant="h2">
              And The Adaptation Strategies
            </Typography>

          </div>

          {/* IIT Madras */}
          <Typography className={classes.instituteTitle}>
            Indian Institute of Technology Madras
          </Typography>

          <Divider />

        </div>

        <CssBaseline />

        {/* Navigation */}
        <Toolbar className={classes.toolbar}>

          {isMobile ? (
            <DrawerComponent />
          ) : (
            <div className={classes.navlinks}>

              <NavLink
                to="/"
                className={classes.link}
                activeClassName={classes.activeLink}
                exact
              >
                Home
              </NavLink>

              <NavLink
                to="/Research"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                Research
              </NavLink>

              <NavLink
                to="/People"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                People
              </NavLink>

              <NavLink
                to="/Publications"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                Publications
              </NavLink>

              <NavLink
                to="/Events"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                Events
              </NavLink>

              <NavLink
                to="/Gallery"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                Gallery
              </NavLink>

              <NavLink
                to="/Presscoverage"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                Presscoverage
              </NavLink>

              <NavLink
                to="/Contact"
                className={classes.link}
                activeClassName={classes.activeLink}
              >
                Contact us
              </NavLink>

            </div>
          )}

        </Toolbar>

      </AppBar>
    </>
  );
};

export default Navbar;